import { Controller } from "@hotwired/stimulus"

// Gates the "Next test" button on the Evaluate Results step until the user
// rates at least one response. The Best/Poor rating buttons submit
// turbo-stream forms inside this element, so any successful submit unlocks
// the button.
export default class extends Controller {
  static targets = ["nextButton"]

  voteRecorded(event) {
    if (event.detail && event.detail.success === false) return

    this.nextButtonTargets.forEach((button) => {
      button.classList.remove("disabled")
      button.removeAttribute("aria-disabled")
      button.removeAttribute("tabindex")
      button.title = "Clear these results and test another prompt"
    })
  }
}
